import React from "react";
import { Link } from "react-router-dom";

import { Box } from "@mui/system";

const Footer = () => {
  return (
    <Box
      sx={{
        color: "color.blueLight",
        background: "#F0F6FA",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      className="navbar">
      <Box
        sx={{
          width: "90%",
          maxWidth: "600px",
        }}>
        <Box
          className="footer-nav"
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-evenly",
          }}>
          {/* <Link to="/gecco">FAQ</Link> */}
          <Link to="/digitalsolution">Kontakt</Link>
          <Link to="/imprint" target="_blank">
            Impressum
          </Link>
          <Link to="/uber-uns">Über uns</Link>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
